/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/prefer-default-export */
import * as yup from 'yup';
/**
 * Add visual filter form validation rules are mentioned here
 */
export const addVisualFilterValidation = yup.object().shape({
  type: yup.string().nullable().required('Type is a required field'),
  tableName: yup
    .string()
    .trim()
    .required('Table Name is a required field')
    .matches(/^\w+( +\w+)*$/, 'Table Name cannot contain special characters'),
  columnName: yup.string().required('Column Name is a required field'),
  startDate: yup.date().nullable(),
  endDate: yup.date().nullable(),
  isDefault: yup.boolean().required('Default is a required field'),
  tags: yup.array().required().min(1, 'At least one tag is required'),
  values: yup.mixed().when('type', (type) => {
    if (type === 'ALL' || type === 'DATE') {
      return yup.mixed().nullable();
    }
    if (type === 'NAME' || type === '') {
      return yup.mixed().required('Values is a required field');
    }
    return yup.array().of(
      yup.object().shape({
        label: yup.string().required('Label is required'),
        value: yup.mixed().required('Value is a required field'),
        isDefault: yup.boolean().nullable(),
        columnName: yup.string().required('Column Name is a required field'),
      })
    );
  }),
});
/**
 * Update visual filter form validation rules are mentioned here
 */
export const updateVisualFilterValidation = yup.object().shape({
  type: yup.string().nullable().required('Type is a required field'),
  tableName: yup
    .string()
    .trim()
    .required('Table Name is a required field')
    .matches(/^\w+( +\w+)*$/, 'Table Name cannot contain special characters'),
  columnName: yup.string().required('Column Name is a required field'),
  startDate: yup.date().nullable(),
  endDate: yup.date().nullable(),
  isDefault: yup.boolean().required('Default is a required field'),
  tags: yup.array().min(1, 'At least one tag is required'),
  values: yup.mixed().when('type', (type) => {
    if (type === 'ALL' || type === 'DATE') {
      return yup.mixed().nullable();
    }
    if (type === 'NAME') {
      return yup.mixed().required('Values is a required field');
    }
    return yup.array().of(
      yup.object().shape({
        label: yup.string().required('Label is required'),
        value: yup.mixed().required('Value is a required field'),
        isDefault: yup.boolean().nullable(),
        columnName: yup.string().required('Column Name is a required field'),
      })
    );
  }),
});
